import simCardReducer from './reducer';
import * as simCardActions from './reducer';

export { simCardActions };

export default simCardReducer;
